export type TypeaheadHintState = {
  state: 'default' | 'error' | 'warning';
  stateText: string;
};

type TypeaheadHintSources = {
  error: string | undefined;
  /** The input mode's hint while the mode comes from text the user is editing. */
  liveModeHint?: TypeaheadHintState | null;
  /** The hint of the mode a revert happened in, until the next focus or edit. */
  revertModeHint?: TypeaheadHintState | null;
  showRevertWarning: boolean;
  /** The input mode's hint while the mode comes from the saved value. */
  savedModeHint?: TypeaheadHintState | null;
  defaultHint: string;
  revertWarning: string;
};

/** Priority for a typeahead field's bottom hint: live mode > revert mode > validation error > revert warning > saved mode > default. */
export const resolveTypeaheadHintState = ({
  error,
  liveModeHint,
  revertModeHint,
  showRevertWarning,
  savedModeHint,
  defaultHint,
  revertWarning,
}: TypeaheadHintSources): TypeaheadHintState => {
  if (liveModeHint) return liveModeHint;
  if (revertModeHint) return revertModeHint;
  if (error) return { state: 'error', stateText: error };
  if (showRevertWarning) return { state: 'warning', stateText: revertWarning };
  if (savedModeHint) return savedModeHint;
  return { state: 'default', stateText: defaultHint };
};
